import { EditorActionKey } from "../../../actions/ActionKeys";
import { EditorAction } from "../../../actions/editor";

/** Manages editor kernel busy/idle changes. */
export const isKernelRunning = (
  state: boolean = false,
  action: EditorAction
): boolean => {
  switch (action.type) {
    case EditorActionKey.SET_EDITOR_KERNEL_IS_RUNNING:
      return action.payload.isRunning;
    default:
      return state;
  }
};
